import { Icon } from '@sr/ui-library';

export const pdfIcon = <Icon className="text-ui-danger" icon="filePdf" />;
export const csvIcon = <Icon className="text-ui-success" icon="fileCsv" />;
